module.exports = __webpack_public_path__ + "img/sen_tempvibe.b8640f99.png";